import React from 'react'

import { Navigate, useNavigate } from 'react-router-dom'


export const Salir = () => {

    const navigate = useNavigate();

    const salir = () => {
        localStorage.clear();
        window.location.reload();

        navigate('/escritorio')
    }
    return (
        <button className='btn btn-lg  rounded-pill  ' style={{ color:'#8ba1b7' }} onClick={ () => salir()} >
            <i className="fa-solid fa-arrow-right-from-bracket"></i>
        </button>
    )
}
